<template>
  <Content id="collectionLog">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="条形码" :label-width="60"><el-input v-model="search.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem></Col>
          <Col><FormItem label="姓名"><el-input v-model="search.name" :maxlength="50" :clearable="true"/></FormItem></Col>
          <Col><FormItem label="证件号码" :label-width="75"><el-input v-model="search.idCard" :maxlength="18" :clearable="true" style="width: 100%;"/></FormItem></Col>
          <Col>
            <FormItem label="体检任务" prop="taskId" :label-width="75">
              <el-select v-model.trim="search.taskId" placeholder="体检任务"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="min-width: 110px;" :clearable="true">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="barCode" label="条形码" min-width="110"/>
      <el-table-column fixed align="center" prop="name" label="姓名" min-width="80"/>
      <el-table-column fixed align="center" prop="idCard" label="证件号码" min-width="150"/>
      <el-table-column fixed align="center" prop="taskName" label="体检任务" min-width="200"/>
      <el-table-column fixed align="center" prop="lacunary" label="缺项" min-width="200"/>
      <el-table-column fixed align="center" prop="remark" label="收表说明" min-width="200"/>
      <el-table-column fixed align="center" prop="status" label="状态" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.status === 2 ? 'danger' : 'primary'" disable-transitions>{{  row.status == 2 ? '取消收表' : '收表' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column fixed align="center" prop="createTime" label="收表时间" min-width="130"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="45" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="handleDetail(row)" :disabled="row.deleteTime>0">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="editWindow" width="80%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false" footer-hide>
      <CollectionLogDetail ref="detail" :style="{'max-height':modalHeight , 'overflow-y': 'auto'}" />
    </Modal>

  </Content>
</template>
<script>
import {_page} from "@/services/operationRecord/collectionLog.js";
import CollectionLogDetail from "./CollectionLogDetail.vue";
import {enums} from "@/services/enums";
import {mixins} from "@/mixins";
export default {
  name: "CollectionLog",
  mixins: [mixins],
  components: {
    CollectionLogDetail
  },
  computed: {
    modalHeight() {
      // 根据屏幕宽度分段设置高度（示例值可调整）
      if (this.windowWidth <= 768) { // 移动端
        return `${this.windowHeight * 0.8}px`;
      } else if (this.windowWidth <= 1366) { // 小屏PC
        return '600px';
      } else { // 大屏
        return '700px';
      }
    }
  },
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        taskId:"",
        barCode:"",
        schoolId:"",
        gradeId:"",
        classesId:"",
        name:"",
        idCard:"",
        status:1
      },
      taskList:[],
      editWindow:false,
      windowTitle:"详情",
      enums:enums,
      dataList: [],
      statusList:[
        {label: '全部', value: 1},
        {label: '已收表', value: 2},
        {label: '取消收表', value: 3},

      ],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  async mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.applyTaskList();
      this.handleDataList();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {

      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    handleDetail(row) {
      this.windowTitle = "收表日志详情";
      this.editWindow = true;
      this.$refs["detail"].handleModal(row);
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 5px;vertical-align: top;zoom: 1;}
/deep/ .el-input__inner {height: 32px;line-height: 32px;}
/deep/ .el-input__icon{line-height: 32px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
/deep/ .el-table .el-table__cell {padding: 10px 0;}

</style>
